import React, { useState } from 'react';
import Switch from 'react-switch';
import "./language-selector.css";
import { useTranslation } from 'react-i18next';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [checked, setChecked] = useState(i18n.language === 'pt');

  const handleChange = (nextChecked) => {
    setChecked(nextChecked);
    const newLang = nextChecked ? 'pt' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <div className='language-toggle'>
      <span className={`language-label ${!checked ? 'active' : ''}`}>En</span>
      <Switch
        checked={checked}
        onChange={handleChange}
        onColor="#4CAF50"
        offColor="#4CAF50"
        onHandleColor="#fff"
        offHandleColor="#fff"
        handleDiameter={20}
        uncheckedIcon={false}
        checkedIcon={false}
        height={24}
        width={48}
        className='language-switch'
      />
      <span className={`language-label ${checked ? 'active' : ''}`}>Pt</span>
    </div>
  );
};

export default LanguageSelector;
